import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { validatePermissions } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { AuthState } from '../../../../services/redux/authSlice';
import CostCenters from './components/CostCenters';
import FinancialNodes from './components/Nodes';

const tabs = [
  {
    index: 0,
    label: 'Cuentas',
    component: <FinancialNodes />,
    path: 'nodes',
  },
  {
    index: 1,
    label: 'Centros de costo',
    component: <CostCenters />,
    path: 'costCenters',
  },
];
const AccountingTab = () => {
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const { subPage } = useParams<{
    id: string;
    businessId: string;
    subPage: string;
    page: string;
  }>();
  const [loading, setLoading] = useState(false);
  const [companyTabs, setCompanyTabs] = useState<any>([]);
  const navigate = useNavigate();

  const [startValue, setStartValue] = useState(0);
  const handleNavigation = (index: number) => {
    navigate(`/settings/accounting/${companyTabs[index].path}`);
  };

  const setUpTabs = async () => {
    setLoading(true);
    const availableTabs: any = [];
    if (validatePermissions(user, 'settings_accounting')) {
      availableTabs.push(tabs[0]);
      availableTabs.push(tabs[1]);
    }

    let startValueDefault = 0;
    startValueDefault = availableTabs.findIndex((x: any) => x.path === subPage);
    setCompanyTabs(availableTabs);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    setLoading(false);
  };

  useEffect(() => {
    setUpTabs();
  }, []);
  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhancedTab
        tabType="secondary"
        startValue={startValue}
        tabs={companyTabs}
        onTabChange={handleNavigation}
        // canShowTab={checkCanAccessView()}
      />
    </div>
  );
};
export default AccountingTab;
